import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement, useContext } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { EnableFor } from '../../../containers/EnableForRole';
import { MAX_FILE_NAME_LENGTH } from '../../../helpers/global.constants';
import { InputStatus } from '../../../models/error.model';
import { DatasetDetails } from '../DatasetDetails.context';
import { useDatasetPermissions } from '../datasets.permissions';

interface IRenameImageModalProps {
  showRenameImage: boolean;
  renameImageName: string;
  renameImageNameStatus: InputStatus;
  toggleRenameImage: () => void;
  onNameChange: (value: string) => void;
  onRenameSave: () => Promise<void>;
}

export const RenameImageModal = observer((props: IRenameImageModalProps): ReactElement => {
  const { t } = useTranslator();
  const permissions = useDatasetPermissions();
  const context = useContext(DatasetDetails);

  return (
    <S_Modal
      isOpen={props.showRenameImage}
      toggle={props.toggleRenameImage}
      headerText={t('rename_image')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.toggleRenameImage}
          >
            {t('cancel')}
          </Button>
          <EnableFor hasPermission={permissions.canRenameImages(context.store.details.status, context.store.details.createdById)}>
            <Button
              disabled={props.renameImageNameStatus.isValid !== true}
              onClick={() => {
                void props.onRenameSave();
              }}
            >
              {t('rename')}
            </Button>
          </EnableFor>
        </>
      }
    >
      <ValidatedTextInput
        onPressEnter={() => {
          void props.onRenameSave();
        }}
        labelText={t('image_name')}
        placeholder={t('type_image_name_here')}
        value={props.renameImageName}
        onChange={props.onNameChange}
        isValid={props.renameImageNameStatus.isValid}
        feedbacks={props.renameImageNameStatus.errorCodes}
        maxLength={MAX_FILE_NAME_LENGTH}
      />
    </S_Modal>
  );
});
